import React from 'react';
import CommonButton from '../common/commonButton';
import type { BannerProps } from './whitelabelBanner.types';
import WirewaxNameLogo from '../../assets/wirewax-name-logo';
import { LogoWrapper, BannerWrapper, TextWrapper, ContentWrapper } from './whitelabelBanner.styles';

const WhitelabelBanner = ({ onClick, subText, buttonText }: BannerProps) => (
    <BannerWrapper>
        <LogoWrapper onClick={() => window.open('https://www.wirewax.com/?ref=embedder')}>
            <WirewaxNameLogo />
        </LogoWrapper>
        <ContentWrapper>
            <TextWrapper>{subText}</TextWrapper>
            <CommonButton
                mediaWidthMd="150px"
                mediaWidthLg="200px"
                fontSize="2em"
                mobileFont="4em"
                onClick={onClick}
            >
                {buttonText}
            </CommonButton>
        </ContentWrapper>
    </BannerWrapper>
);

export default WhitelabelBanner;
